import React, {useState} from "react"
import {Body} from "@irati/ui/src/Typography"
import {PointsBlendModal} from "@irati-web/platform/src/components/PointsBlendModal/PointsBlendModal"
import Flex from "@irati/ui/src/Flex"
import {FormattedCurrency} from "@irati/utils/lang"
import IconButton from "@irati/ui/src/Button/IconButton"
import {UseBasket} from "@irati/checkout/utils/basket/useBasket"
import {FlexStyles, SubTotal} from "./OrderSummaryTT"

export function PointsBreakdown({pointBreakdown}: {pointBreakdown: NonNullable<UseBasket["pointBreakdown"]>}) {
  const [modalShown, setModalShown] = useState(false)
  const {RP, TT} = pointBreakdown.spent
  return (
    <>
      <FlexStyles />
      <SubTotal className="flex-override">
        <Flex gap={1} alignItems="center">
          <div style={{height: "16px" /* go away bootstrap */}}>
            <IconButton onClick={() => setModalShown((s) => !s)} icon="circleQuestion" inline />
          </div>
          <Body small>Subtotal</Body>
        </Flex>
        <Body small style={{display: "flex", flexDirection: "row", gap: "4px"}}>
          <FormattedCurrency currency={TT.currency} value={TT.amount} />
          <span>+</span>
          <FormattedCurrency currency={RP.currency} value={RP.amount} />
        </Body>
      </SubTotal>
      <hr />
      <PointsBlendModal shown={modalShown} onClose={() => setModalShown(false)} />
    </>
  )
}
